import { DropdownTrigger } from 'components/dropdown/DropdownTrigger';
import { MediaQueries } from 'custom_hooks/useWindowSize';
import { dropdownTriggerStyles } from 'pages/Desk/issues/issue_modals/shared';
import styled, { css } from 'styled-components';

const lightBackgroundStyle = css`
    border: 2px solid var(--border-default);
    border-width: 2px !important;
    background: var(--background-paper-elevation-4);
`;

export const InputTrigger = styled(DropdownTrigger).attrs<{ $lightBackground?: boolean }>(
    {
        paddingOverride: '1.5y',
        style: dropdownTriggerStyles,
    }
)`
    background: var(--input-background);
    border-radius: 3px;
    margin-top: 0.5rem;

    position: relative;

    ${({ $lightBackground }) => ($lightBackground ? lightBackgroundStyle : '')};
`;

export const InputCurrentValue = styled.div`
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    gap: 0.5rem;
    flex-wrap: wrap;
    max-height: 12rem;
    overflow-y: auto;
`;

export const FaultTypePopupContentContainer = styled.div`
    box-sizing: border-box;
    flex-grow: 1;
    display: grid;
    grid-template-rows: auto 1fr auto;
    padding: 1rem;
    gap: 1rem;

    @media ${MediaQueries.mediumAndUp} {
        width: 40rem;
        grid-template-rows: auto 1fr auto;
    }
`;

export const FaultTypePopupContentTree = styled.div`
    overflow-y: auto;
    padding-right: 1rem;
    font-size: 1.4rem;
`;

export const FaultTypeTreeItem = styled.div<{ $isRoot: boolean }>`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0.6rem 0.6rem;
    font-weight: ${({ $isRoot }) => ($isRoot ? '500' : 'auto')};
    font-size: ${({ $isRoot }) => ($isRoot ? '1.2rem' : '1.4rem')};
`;

export const FaultTypeTreeItemWithTrailer = styled.div<{ $isRoot: boolean }>`
    display: grid;
    grid-template-columns: 1fr 5.5rem;
    align-items: center;
    gap: 0.5rem;
    margin: 0.6rem 0.6rem;
    font-weight: ${({ $isRoot }) => ($isRoot ? '500' : 'auto')};
    font-size: ${({ $isRoot }) => ($isRoot ? '1.2rem' : '1.4rem')};
`;

export const FaultTypePopupContentFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 1rem;

    button {
        padding: 1rem;
    }
`;

export const ChildrenLozenge = styled.button<{ $hasAnySelected?: boolean }>`
    display: inline-flex;

    margin-left: auto;
    outline: 1px solid var(--border-default);
    padding-inline: 0.6rem;
    border-radius: 5px;
    background-color: transparent;
    font-size: 1.2rem;

    color: ${({ $hasAnySelected }) =>
        $hasAnySelected ? 'var(--text-primary)' : 'var(--text-secondary)'};

    & > span {
        word-break: keep-all;
        white-space: nowrap;
    }

    .icon {
        width: 0;
        visibility: hidden;
        margin-right: 0;
    }

    &:hover {
        background-color: var(--action-hover);
        cursor: pointer;

        .icon {
            visibility: visible;
            width: auto;
            margin-right: 0.4rem;
        }
    }

    &:active {
        outline-color: var(--border-focus);
    }
    box-shadow: unset;
`;
